import { useSelector } from 'react-redux'
import { RootState } from '@AppState/redux-store'
import { DataFetchingState } from '@AppState/types'
import { UserMessage } from '@Components/common/user-message'
import { useEffect } from 'react'

export const Maintenance = () => {
  const { fetchState: hostConfigFetchState } = useSelector((state: RootState) => state.hostConfig)
  const { config } = useSelector((state: RootState) => state.appConfig)
  const { gameRules, fetchState: gameConfigFetchState } = useSelector(
    (state: RootState) => state.gameConfig,
  )

  useEffect(() => {
    // Try going back to the main page once a minute
    const redirectInterval = setInterval(() => {
      window.location.href = `/?host-name=${config?.hostName}&client-id=${config?.clientId}`
    }, 60000)

    return () => {
      clearInterval(redirectInterval)
    }
  }, [config?.clientId, config?.hostName])

  const useDefault =
    hostConfigFetchState === DataFetchingState.FAILED ||
    gameConfigFetchState === DataFetchingState.FAILED

  return (
    <UserMessage
      title="We're Making Things Even Better!"
      message={`Our app is currently undergoing maintenance to bring you an even smoother ${useDefault ? '' : gameRules?.at(0)?.name} experience. We'll be back up and running soon.`}
    />
  )
}
